import { render } from "./apiDoc.vue?vue&type=template&id=59c8dde2&scoped=true"
import script from "./apiDoc.vue?vue&type=script&lang=js"
export * from "./apiDoc.vue?vue&type=script&lang=js"

import "./apiDoc.vue?vue&type=style&index=0&id=59c8dde2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c8dde2"]])

export default __exports__